import { useState, useEffect } from 'react';
import { fetchProjectsSummary } from '../services/projectService';

export const useProjectsSummary = (filters = {}, page = 0, size = 10) => {
  const [data, setData] = useState({ content: [], totalElements: 0, totalPages: 0, number: 0, size: 10 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadProjects = async () => {
      try {
        setLoading(true);
        const response = await fetchProjectsSummary(filters, page, size);
        setData(response);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadProjects();
  }, [filters, page, size]);

  return { ...data, loading, error };
};